import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Link } from 'react-router-dom';
import { nafColor } from '@nafcore/theme';
import { radius } from '@naf/theme';
import { isNotTransientProp } from '../../lib/shouldForwardProp';

export const StyledLink = styled(Link, { shouldForwardProp: isNotTransientProp })<{ $hasCardGrid?: boolean }>`
  text-decoration: none;
  height: fit-content;

  &:hover {
    color: inherit;
  }

  ${({ $hasCardGrid }) =>
    $hasCardGrid &&
    css`
      display: flex;
      width: 100%;
      height: 100%;

      /* The Simba Card sizes to its content, so let it fill the grid cell. */
      > * {
        flex: 1;
      }

      /* The Simba Card is not focusable when nested in a link, so the link owns the ring. */
      &:focus-visible {
        outline: 2px solid ${nafColor.signature.black};
        outline-offset: 2px;
        border-radius: ${radius.s};
      }
    `}
`;

export const NavCardLink = styled(Link, { shouldForwardProp: isNotTransientProp })<{ $hasCardGrid?: boolean }>`
  display: flex;
  width: 100%;
  height: 100%;
  text-decoration: none;

  /* The Simba card sizes to its content, so let it fill the grid cell. */
  > * {
    flex: 1;
  }

  /* The Simba card is not focusable when nested in a link, so the link owns the ring. */
  &:focus-visible {
    outline: 2px solid ${nafColor.signature.black};
    outline-offset: 2px;
    border-radius: ${radius.s};
  }

  &:hover {
    color: inherit;
  }
`;
